import React, { useEffect, useState } from "react";
import PrivateApi from "../../services/PrivateApiService";
import { Button, Col, Container, Row, Spinner } from "react-bootstrap";
import { FaBaby, FaFileSignature, FaRegFilePdf } from 'react-icons/fa';
import { MdDoubleArrow } from "react-icons/md";
import TimelineFilters from "../../components/customer/TimeLineFilters";
import TLineComponent from "../../components/customer/TLineComponent";
import NotificationModal from "../../components/shared/notification/NotificationModal";
import { useQuery } from "react-query";
import SplashPage from "../SplashPage";
import { useParams } from "react-router-dom";


const TimeLinePage = () => {

    // API
    const API = new PrivateApi();
    const { anlage } = useParams();

    // State from data
    const [anlagen, setAnlagen] = useState([]);
    const [selectedAnlageId, setSelectedAnlageId] = useState(0);
    const [elvs, setElvs] = useState([]);
    const [selectedElvs, setSelectedElvs] = useState([]);
    const [historyElvs, setHistoryElvs] = useState([]);
    const [poolAccessionDate, setPoolAccessionDate] = useState("");
    const [items, setItems] = useState([]);
    const [filteredItems, setFilteredItems] = useState([]);
    const [notifications, setNotifications] = useState([]);
    const [isVollmachtDownload, setIsVollmachtDownload] = useState(false);
    const [tabData, setTabData] = useState([{id: 1, name:"Aktuell", count: 0, selected: false}, {id: 2, name:"Historisch", count: 0, selected: false}]);

    // Query calls
    const { data, error, isLoading } = useQuery("TIMELINE", API.client_timeline, { staleTime: Infinity });

    // When data is recived from API
    useEffect(() => {
        if (data !== undefined) {
            let result = data.data;
            setAnlagen(result.anlagen);
            setSelectedAnlageId(result.anlagen[0].id);
            setElvs(result.elvs);
            if (result.elvs.filter(e => new Date(e.x_datum_vertragsende) > new Date()).length > 0) {
                setTabData(prev => prev.map(tab => tab.name === "Aktuell"? {...tab, count: 1, selected: true}: tab));
            }
            if (result.elvs.filter(e => new Date(e.x_datum_vertragsende) < new Date()).length > 0) {
                setTabData(prev => prev.map(tab => tab.name === "Historisch"? {...tab, count: 1}: tab));
            }
            setSelectedElvs(result.elvs.filter(e => e.x_anlage_id[0] === result.anlagen[0].id && new Date(e.x_datum_vertragsende) > new Date() ));
            setHistoryElvs(result.elvs.filter(e => e.x_anlage_id[0] === result.anlagen[0].id && new Date(e.x_belbeg) < new Date() && new Date(e.x_datum_vertragsende) < new Date() ));
            setPoolAccessionDate(result.x_pool_accession_date);

            var itemTemp = result.poolrechnungen.concat(result.abrechnungen).concat(result.vorschreibungen);
            if (Array.isArray(itemTemp) && itemTemp.length > 1) {
                itemTemp.sort((a, b) => new Date(a.x_rechnungsdatum ? a.x_rechnungsdatum : a.x_eingangsdatum ? a.x_eingangsdatum : a.create_date) - new Date(b.x_rechnungsdatum ? b.x_rechnungsdatum : b.x_eingangsdatum ? b.x_eingangsdatum : b.create_date)).reverse();
            }
            setItems(itemTemp);
            itemTemp = itemTemp.filter(i => i.x_anlage_id[0] === result.anlagen[0].id);
            setFilteredItems(itemTemp);

            if (anlage !== undefined && anlage !== null) {
                setSelectedAnlageId(data.data.anlagen.filter(a => a.x_studio_field_mWMGR === anlage)[0].id);
                setFilteredItems(itemTemp.filter(i => i.x_anlage_id[0] === selectedAnlageId));
            }
        }
    }, [data]);


    // When another anlage is selected/clicked
    useEffect(() => {
        if (elvs && elvs.length > 0) {
            setSelectedElvs(elvs.filter(e => e.x_anlage_id[0] === selectedAnlageId && new Date(e.x_datum_vertragsende) > new Date()));
            setHistoryElvs(elvs.filter(e => e.x_anlage_id[0] === selectedAnlageId && new Date(e.x_belbeg) < new Date() && new Date(e.x_datum_vertragsende) < new Date()))
        }
        if (items && items.length > 0) {
            var itemTemp = items.filter(i => i.x_anlage_id[0] === selectedAnlageId);
            setFilteredItems(itemTemp)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedAnlageId])


    const vollmachtBtnHandler = () => {
        setIsVollmachtDownload(true);
        API.client_timeline_vollmacht()
            .then((res) => {
                let data = res.data;
                const linkSource = `data:application/pdf;base64,${data.file}`;
                let fileName = data.fila_name;
                const downloadLink = document.createElement('a');

                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                setIsVollmachtDownload(false);
                
            })
    }


    
    if (isLoading) return <SplashPage /> ;
    if (error) return <SplashPage error={error} />;

    return (
        <Container fluid>
            <Row className="text-start mt-3 mb-5">
                <Col>
                    <h3>Ihre Anlagen bei <span className="text-energo">ENERGO</span> im Zeitverlauf</h3>
                    <p className="text-muted">
                        Diese Ansicht zeigt all Ihre Anlagen und die entsprechenden Energielieferverträge in chronologischer Reihenfolge.
                    </p>
                </Col>
            </Row>
            <TimelineFilters anlagen={anlagen} selected={selectedAnlageId} setSelected={setSelectedAnlageId} tabData={tabData} setTabData={setTabData} />

            <Container className="mt-3" hidden={tabData[0].selected === false}>
                <Row>
                    <Col>
                        <h4 className="text-energo">Aktuelle Energielieferverträge</h4>
                    </Col>
                </Row>
            </Container>
            <TLineComponent items={filteredItems} elvs={selectedElvs} hidden={tabData[0].selected === false} />
            <hr className="mt-5" hidden={tabData[0].selected === false} />
            <Container className={tabData[0].selected === false? "mt-5": "mt-3"} hidden={tabData[1].selected === false}>
                <Row>
                    <Col>
                        <h4 className="text-energo">Historische Energielieferverträge</h4>
                    </Col>
                </Row>
            </Container>
            <TLineComponent items={filteredItems} elvs={historyElvs} hidden={tabData[1].selected === false} opaque/>

            <Row className="justify-content-center align-items-center " style={{ borderTop: "3px solid #a2c13f", marginTop: "100px" }}>
                <Col xs="5" xl="2" className="mt-5 text-center">
                    <FaFileSignature className="text-energo" size={50} />
                    <br />
                    <Button onClick={() => vollmachtBtnHandler()} disabled={isVollmachtDownload} className="btn-energo btn-sm rounded-pill mt-2">
                        {isVollmachtDownload ? 
                            <Spinner animation="border" size="sm" />
                            :
                            <>
                                <FaRegFilePdf /> &nbsp;
                                Vollmacht
                            </>
                        }
                    </Button>
                </Col>
                <Col xs="2" className="mt-5 text-center">
                    <MdDoubleArrow className="text-muted" size={60} />
                </Col>
                <Col xs="5" xl="2" className="mt-5 text-center">
                    <div className="circle-icon border-energo" style={{ marginRight: "0px" }}>
                        <FaBaby className="text-energo" size={50} />
                    </div>
                    <br />
                    <span className="text-energo">Poolbeitritt</span>
                    <p>{new Date(poolAccessionDate).toLocaleDateString('DE-de')}</p>
                </Col>
            </Row>

            {notifications && notifications.length > 0 ?
                <NotificationModal notifications={notifications}/>
                :
                null
            }
        </Container>
    )
}

export default TimeLinePage;